export enum B2cAuthErrorTypes {
  MissingToken = 'missingtoken',
  AccesDenied = 'accessdenied',
  UnknownError = 'unknownerror',
  InvalidToken = 'invalidtoken',
}
